import clsx from "clsx";

import type { ColumnStoryblok } from "@/types/blok-types";

import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import styles from "./column.module.css";

const Column = ({
  blok,
  preview,
}: {
  blok: ColumnStoryblok;
  preview: boolean;
}): React.JSX.Element => {
  return (
    <div
      className={clsx(styles.root)}
      data-position-y={blok.position_y}
      data-position-x={blok.position_x}
    >
      <StoryblokComponent
        key={blok._uid}
        blok={blok.content?.[0]}
        preview={preview}
      />
    </div>
  );
};

export default Column;
